export default __webpack_public_path__ + "static/media/boot.83e9db96.png";